const firebaseConfig = {
    apiKey: "AIzaSyAV579Nqh0GyZvaff4qF_n-YZUQaGz6atI",
    authDomain: "cycle-shop-542b8.firebaseapp.com",
    projectId: "cycle-shop-542b8",
    storageBucket: "cycle-shop-542b8.appspot.com",
    messagingSenderId: "108097285682",
    appId: "1:108097285682:web:178ac5ae49f5758af3562b"
};
export default firebaseConfig;